// import external libraries
import { useCallback, useMemo, useState } from 'react';

// import types
import type { SingleOrRange } from 'components/shared/DateNavigation/DateNavigation.types';

// import utils
import { getEightWeekInterval } from 'utils/date';
import dayjs from 'dayjs';

export const usePrescriptionDateInterval = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const dateInterval = useMemo(
    () => getEightWeekInterval(selectedDate),
    [selectedDate]
  );

  const onDateChange = useCallback((date: SingleOrRange | null) => {
    if (!date) return;
    const raw = Array.isArray(date) ? date[0] : date;
    if (!raw) return;
    setSelectedDate(dayjs.isDayjs(raw) ? raw.toDate() : raw);
  }, []);

  return { selectedDate, dateInterval, onDateChange };
};
